import { render, staticRenderFns } from "./TheFavorite.vue?vue&type=template&id=0865747a&scoped=true&"
import script from "./TheFavorite.vue?vue&type=script&lang=js&"
export * from "./TheFavorite.vue?vue&type=script&lang=js&"
import style0 from "./TheFavorite.vue?vue&type=style&index=0&id=0865747a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865747a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VContainer,VIcon,VScaleTransition})
